import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import Price from '@/checkout-instore-legacy/components/Commons/Price'
import IconArrowRight from '@/checkout-instore-legacy/components/Commons/Icons/ArrowRight'
import { formatSimpleDate } from '@/checkout-instore-legacy/utils/DateUtils'

function parseUserName(name, intl) {
  if (!name || name === '') {
    return intl.formatMessage({
      id: 'anonymousLabel',
    })
  }
  return name
}

const Order = ({
  customerName,
  orderFormId,
  code,
  numberOfItems,
  value,
  date,
  isSelected,
  onClick,
  intl,
}) => {
  const tablet = window.innerWidth > 600
  const paidValue = 0

  return (
    <div
      className={`pointer hover-bg-light-silver bg-animate flex pl4 pl5-ns bb b--black-20 ${
        isSelected ? 'bg-light-silver' : ''
      }`}
      onClick={() => onClick(orderFormId, code)}
    >
      <div className="flex-auto pv5 pv6-ns pl4 pl5-ns noselect">
        <div className="mb4 mb5-ns f5 fw7 f3-ns c-action-primary">
          {parseUserName(customerName, intl)}
        </div>
        <div className="gray fw3 f6 f4-ns">
          {numberOfItems > 0 && (
            <span>
              <Price value={value} />
              {paidValue > 0 && (
                <React.Fragment>
                  <span>{' - '}</span>
                  <span className="green b">
                    <Price value={paidValue} /> <FormattedMessage id="paid" />
                  </span>
                </React.Fragment>
              )}
              <span className="order-data-sep ml4 mr4">{'|'}</span>
            </span>
          )}
          <span className="order-quantity">
            <FormattedMessage
              id="orderQuantityOfItems"
              values={{ numberOfItems }}
            />
          </span>
          {date ? (
            <span>
              <span className="order-data-sep">
                {' '}
                <span className="mr4 ml4">{'|'}</span>
              </span>
              <span>{formatSimpleDate(new Date(date))}</span>
            </span>
          ) : null}
        </div>
      </div>

      <div className="flex-none self-center pr5 pr6-ns">
        <IconArrowRight
          width={tablet ? 28 : 16}
          height={tablet ? 28 : 16}
          color={'#DDDDDD'}
        />
      </div>
    </div>
  )
}

Order.propTypes = {
  customerName: PropTypes.string.isRequired,
  orderFormId: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  numberOfItems: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  date: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  intl: intlShape.isRequired,
}

Order.defaultProps = {
  onClick: () => {},
}

export default injectIntl(Order)
